import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import SyncIcon from '@mui/icons-material/Sync';
import PowerSettingsNew from '@mui/icons-material/PowerSettingsNew';
import { theme } from 'utils/theme';
import { isActive } from 'utils/misc';
import { IconButtonWithTooltip } from 'components/IconButtonWithTooltip';

export const renderEditButton = (params, setTeamId, setIsTeamModalOpen) => {
    const handleEditClick = () => {
        setTeamId(params.row.id);
        setIsTeamModalOpen(true);
    };

    if (isActive(params.row)) {
        return (
            <IconButtonWithTooltip
                onClick={handleEditClick}
                icon={<EditIcon />}
                tooltipText="Edit"
                color={theme.palette.primary.main}
            />
        );
    } else {
        return null;
    }
};

export const renderDeleteReactivateButton = (
    params, 
    setTeamId, 
    setIsDeleteTeamModalOpen,
    setIsReactivateTeamModalOpen
) => {
    const handleDeleteClick = () => {
        setTeamId(params.row.id);
        setIsDeleteTeamModalOpen(true);
    };

    const handleReactivateClick = () => {
        setTeamId(params.row.id);
        setIsReactivateTeamModalOpen(true);
    };

    return (
        <div>
            {isActive(params.row) ? (
                <IconButtonWithTooltip
                    onClick={handleDeleteClick}
                    icon={<PowerSettingsNew />}
                    tooltipText="Deactivate"
                    color={theme.palette.redColor.main}
                />
            ) : (
                <IconButtonWithTooltip
                    onClick={handleReactivateClick}
                    icon={<SyncIcon />}
                    tooltipText="Reactivate"
                    color={theme.palette.primary.main}
                />
            )}
        </div>
    );
};

export const teamColumns = [
    { field: 'id', headerName: 'ID' },
    {
        field: 'name',
        headerName: 'Name',
        flex: 0.3,
        minWidth: 50,
    },
    {
        field: 'edit',
        headerName: '',
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        width: 120,
        renderCell: renderEditButton,
    },
    {
        field: 'delete-reactivate',
        headerName: '',
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        width: 120,
        renderCell: renderDeleteReactivateButton,
    },
];
